import { EntityItem } from "../../entity/EntityItem";

export class DtoItemImageDeleteRes {
  public message: string | null = null;
}
